import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { UserAvatar } from '../UserAvatar';
import { useAuth } from '../../contexts/AuthContext';
import { useUserData } from '../../hooks/useUserData';
import styles from './UserInfo.module.css';

interface UserInfoProps {
  showAvatar?: boolean;
  showEmail?: boolean;
  showProvider?: boolean;
  showFullName?: boolean;
  variant?: 'compact' | 'detailed';
  className?: string;
}

export const UserInfo: React.FC<UserInfoProps> = ({
  showAvatar = true,
  showEmail = true,
  showProvider = false,
  showFullName = true,
  variant = 'compact',
  className
}) => {
  const { user } = useAuth();
  const { userData } = useUserData();

  // Prioriza dados do contexto, depois dados salvos
  const currentUser = user || userData;

  if (!currentUser) {
    return (
      <Box className={`${styles.userInfo} ${className || ''}`}>
        <Typography variant="body2" color="textSecondary">
          Usuário não encontrado
        </Typography>
      </Box>
    );
  }

  const displayName = showFullName 
    ? currentUser.name 
    : currentUser.given_name || currentUser.name.split(' ')[0];

  return (
    <Box className={`${styles.userInfo} ${styles[variant]} ${className || ''}`}>
      {showAvatar && (
        <UserAvatar 
          size={variant === 'detailed' ? 'large' : 'medium'}
          className={styles.avatar}
        />
      )}
      
      <Box className={styles.userDetails}>
        <Typography 
          variant={variant === 'detailed' ? 'h6' : 'body1'} 
          className={styles.userName}
        >
          {displayName}
        </Typography>
        
        {showEmail && (
          <Typography 
            variant="body2" 
            color="textSecondary"
            className={styles.userEmail}
          >
            {currentUser.email}
          </Typography>
        )}
        
        {showProvider && currentUser.provider && (
          <Chip
            label={currentUser.provider === 'google' ? 'Google' : 'Email'}
            size="small"
            color={currentUser.provider === 'google' ? 'primary' : 'default'}
            className={styles.providerChip}
          />
        )}
        
        {variant === 'detailed' && currentUser.given_name && currentUser.family_name && (
          <Typography variant="body2" color="textSecondary">
            {currentUser.given_name} {currentUser.family_name}
          </Typography>
        )}
      </Box>
    </Box>
  );
};